import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import {
  Form,
  Grid,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  FieldGroup,
  Panel,
  Table,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Itinerary.css';
import FontAwesome from 'react-icons/fa';
import { connect } from 'react-redux';

// Components
import Avatar from '../Avatar';
import CurrencyConverter from '../CurrencyConverter';
import ListCoverPhoto from '../ListCoverPhoto';
import Link from '../Link';
import StarRating from '../StarRating';

// Helper
import { generateTime } from '../Receipt/helper';

// Locale
import messages from '../../locale/messages';
import { Text, Whitespace } from '../../components_new/common';
import Button from '../../components_new/common/FormComponents/Button';
import { getp } from '../../helpers/getProp';

class Itinerary extends React.Component {
  static propTypes = {
    formatMessage: PropTypes.func,
    data: PropTypes.shape({
      id: PropTypes.number.isRequired,
      listId: PropTypes.number.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      guestServiceFee: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      reservationState: PropTypes.string.isRequired,
      listData: PropTypes.shape({
        title: PropTypes.string.isRequired,
        street: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
        zipcode: PropTypes.string.isRequired,
        reviewsCount: PropTypes.number.isRequired,
        reviewsStarRating: PropTypes.number.isRequired,
        listingData: PropTypes.shape({
          checkInStart: PropTypes.string.isRequired,
          checkInEnd: PropTypes.string.isRequired,
        }),
        coverPhoto: PropTypes.number,
        listPhotos: PropTypes.arrayOf({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
        }),
      }),
      messageData: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
      hostData: PropTypes.shape({
        profileId: PropTypes.number.isRequired,
        displayName: PropTypes.string.isRequired,
        picture: PropTypes.string.isRequired,
      }),
    }),
  };

  static defaultProps = {
    data: null,
  };

  render() {
    const { data } = this.props;
    const { formatMessage } = this.props.intl;
    const { userId } = this.props;

    if (data === null) {
      return (
        <div>
          {' '}
          <FormattedMessage {...messages.errorMessage} />{' '}
        </div>
      );
    }
    const {
      data: {
        id,
        listId,
        checkIn,
        checkOut,
        total,
        guestServiceFee,
        currency,
        confirmationCode,
        reservationState,
        hostId,
        guestId,
      },
    } = this.props;
    const {
      data: {
        hostData: { profileId, displayName, picture },
      },
    } = this.props;
    const {
      data: {
        listData: { title, street, city, state, country, zipcode, category },
      },
    } = this.props;
    const {
      data: {
        listData: { coverPhoto, listPhotos, reviewsCount, reviewsStarRating },
      },
    } = this.props;
    const {
      data: { messageData },
    } = this.props;

    const checkInDate = checkIn ? moment(checkIn).format('ddd, Do MMM') : '';
    const checkOutDate = checkOut ? moment(checkOut).format('ddd, Do MMM') : '';
    let momentStartDate, momentEndDate, dayDifference, checkInTime, checkOutTime;
    if (checkIn != null && checkOut != null) {
      momentStartDate = moment(checkIn);
      momentEndDate = moment(checkOut);
      dayDifference = momentEndDate.diff(momentStartDate, 'days');
    }

    checkInTime = 'Placeholder';
    checkOutTime = 'Placeholder';

    const subTotal = total + guestServiceFee;
    let starRatingValue = 0;
    if (reviewsCount > 0 && reviewsStarRating > 0) {
      starRatingValue = Number(reviewsStarRating / reviewsCount);
    }

    let isHost = false;
    if (userId === hostId) {
      isHost = true;
    }

    return (
      <div className="f f-1 f-cc f-rows my-l">
        <div className="w-max-400 f-center-stretch f-rows">
          <Text banner primary>
            Request Sent
          </Text>
          <Whitespace small />
          <Text noclip>
            We let the host know that you're interested. They'll get back to you as soon as they can
            to approve your rental. ( Up to 48 hours )
          </Text>
          <div className="b-1 b-coolGray h-1 my-mxx" />
          <Text class="t-h5 primary">What's next</Text>
          <Whitespace small />
          <div>
            <div className="f f-columns">
              <i className="fal fa-square grayDarkMedium mr-s" />
              <Text inline>
                <Link to={'/inbox/' + getp(messageData, 'id')}>Coordinate</Link> a pickup and return
                time with the host
              </Text>
            </div>
            <div className="f f-columns">
              <i className="fal fa-square grayDarkMedium mr-s" />
              <Text inline noclip>
                Show up with our <Link>smartphone app</Link> on pickup day to record and complete
                the exchange
              </Text>
              <Text />
            </div>
          </div>
          <Whitespace medium />
          <div className="f-cc f-rows">
            <Text large>In the mean time...</Text>

            <Link to={'/s?category=' + category}>
              <Button primary action>
                Check out more stuff
              </Button>
            </Link>
          </div>
          <Whitespace medium />
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  userId: state.account.data.userId,
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(Itinerary)));



// WEBPACK FOOTER //
// ./src/components/Itinerary/Itinerary.js